import { AuthException } from "./auth.exception";

export class InvalidTokenException extends AuthException {}
